module.exports = __webpack_public_path__ + "static/media/Form_Continue_Button@3x.08e88f18.png";